//Action Types
export var CLIENTS_RESET_ACTION_TYPE = "CLIENTS_RESET";
export var CLIENTS_CLEAR_ACTION_TYPE = "CLIENTS_CLEAR";
export var CLIENTS_CLEAR_RETRIEVED_CLIENT_ACTION_TYPE = "CLIENTS_CLEAR_RETRIEVED_CLIENT";
export var CLIENTS_FETCH_START_ACTION_TYPE = "CLIENTS_FETCH_START";
export var CLIENTS_FETCH_SUCCESS_ACTION_TYPE = "CLIENTS_FETCH_SUCCESS";
export var CLIENTS_FETCH_ALL_START_ACTION_TYPE = "CLIENTS_FETCH_ALL_START";
export var CLIENTS_FETCH_ALL_SUCCESS_ACTION_TYPE = "CLIENTS_FETCH_ALL_SUCCESS";
export var CLIENTS_GET_START_ACTION_TYPE = "CLIENTS_GET_START";
export var CLIENTS_GET_SUCCESS_ACTION_TYPE = "CLIENTS_GET_SUCCESS";
export var CLIENTS_SAVE_START_ACTION_TYPE = "CLIENTS_SAVE_START";
export var CLIENTS_SAVE_SUCCESS_ACTION_TYPE = "CLIENTS_SAVE_SUCCESS";
export var CLIENTS_SAVE_AUTHORIZED_CONTACTS_START_ACTION_TYPE = "CLIENTS_SAVE_AUTHORIZED_CONTACTS_START";
export var CLIENTS_SAVE_AUTHORIZED_CONTACTS_SUCCESS_ACTION_TYPE = "CLIENTS_SAVE_AUTHORIZED_CONTACTS_SUCCESS";
export var CLIENTS_DELETE_START_ACTION_TYPE = "CLIENTS_DELETE_START";
export var CLIENTS_DELETE_SUCCESS_ACTION_TYPE = "CLIENTS_DELETE_SUCCESS";
export var CLIENTS_LOGICAL_DELETE_START_ACTION_TYPE = "CLIENTS_LOGICAL_DELETE_START";
export var CLIENTS_LOGICAL_DELETE_SUCCESS_ACTION_TYPE = "CLIENTS_LOGICAL_DELETE_SUCCESS";
export var CLIENTS_ERROR_ACTION_TYPE = "CLIENTS_ERROR";
